import React, { useEffect, useState } from 'react';
import { setYearList,setMonthList,setDateRange,formatDate,mmType,DownloadFile } from './Function';
import { Row,Col,Card,Table,Form,Placeholder,Button } from 'react-bootstrap';
const Meetings = ({mtId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isType, setType] = useState(true);
    const[isLoading, setLoading] = useState(true);
    const[MeetingType,setMeetingType]=useState([]);
    const[Meeting,setMeeting]=useState([]);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        const MeetingType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"meetingType/byId/"+mtId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    result[0].members = await MeetingMembers();
                    setType(false);
                    setMeetingType(result);
                }
                else
                {
                    setType(false);
                    setMeetingType([]);
                }
                if( global.config.IsPrint === true ) { console.info('Meeting Type : Result',result); }
            }
            catch (error) 
            {
                console.error('Meeting Type : Error', error.message);
                setType(false);
            }
        };
        const MeetingMembers = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"meetingMember/byType/"+mtId);
                const result = await response.json();
                return result;
            }
            catch (error) 
            {
                console.error('Meeting Members : Error', error.message);
                return [];
            }
        };
        const MeetingLatest = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"meeting/byTypeLatest/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/smFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/smFileHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].smFile = el.upp;
                            result[i].smFileHi = el.upph;                            
                        });
                        setMeeting(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Meeting File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMeeting([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('Meeting : Result',result); }
            }
            catch (error) 
            {
                console.error('Meeting : Error', error.message);
            }
        };
        MeetingType();
        MeetingMembers();
        MeetingLatest();
    },[mtId])
    const MeetingSearch = async (e) => 
    {
        e.preventDefault();
        if(!keyword && year===0 && month===0)
        {
            alert( appLanguage === "hi" ? "कृपया कम से कम एक कीवर्ड, वर्ष या महीना चुनें!" : "Please Select atleast one Keyword, Year or Month!" );
            return;
        }
        try 
        {
            setLoading(true);
            const { startDate, endDate } = setDateRange(year, month, 1, 0, 0);
            var apiSwitch = (!keyword) ? "meeting/byTypeSearch/"+mtId+"/" : "meeting/byTypeSearchWithKeyword/"+mtId+"/"+keyword+"/";
            const response = await fetch(global.config.API_URL+apiSwitch+startDate+"/"+endDate);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/smFile")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/smFileHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].smFile = el.upp;
                        result[i].smFileHi = el.upph;                            
                    });
                    setMeeting(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('Meeting File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setMeeting([]);
                setLoading(false);
            }
            if( global.config.IsPrint === true ) { console.info('Meeting Search : Result',result); }
        }
        catch (error) { console.error('Meeting Search : Error', error.message); }
    };
    return (
        <React.Fragment>
        {isType ? (
        <Card className='bg-secondary-subtle text-center mb-4'>
            <Card.Header className='fs-3' data-aos="flip-up" data-aos-duration="1500"><Placeholder xs={10} /></Card.Header>
            <Card.Body>
                <p><Placeholder xs={12} /></p>
                <Row className='g-3'>
                {[...Array(6)].map((_,index)=>(
                    <Col md={4} key={index}>
                        <Card className='bg-success-subtle shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                            <Card.Body className='d-flex align-items-center justify-content-center'><Placeholder xs={10} /></Card.Body>
                            <Card.Footer className=' text-uppercase bg-white p-4'><Placeholder xs={10} /></Card.Footer>
                        </Card>
                    </Col>
                ))}
                </Row>
            </Card.Body>
        </Card>
        ) : (
        <React.Fragment>
        {MeetingType.map((mt,index)=>(
        <div key={index}>
            <Card className='bg-secondary-subtle text-center mb-4'>
                <Card.Header className='text-uppercase fs-3' data-aos="flip-up" data-aos-duration="1500">
                    {appLanguage === 'hi' ? (mt.mt_display_en === "1" ? mt.mt_name_hi || '' : mt.mt_name_hi || mt.mt_name) : mt.mt_name}
                </Card.Header>
                <Card.Body>
                    <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (mt.mt_display_en === "1" ? mt.mt_description_hi || '' : mt.mt_description_hi || mt.mt_description) : mt.mt_description}} />
                    {mt.members && <Table responsive bordered className='text-center mb-0'>
                        <tbody>
                        {mt.members.map((mm,index)=>(
                            <tr key={index}>
                                <td width={60}>{`${index + 1}.`}</td>
                                <th className="w-75 table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? mm.mm_name_hi || mm.mm_name : mm.mm_name}}></th>
                                <td>{mmType(mm.mm_type)}</td>                                                            
                            </tr>
                        ))}
                        </tbody>
                    </Table>}                    
                </Card.Body>
            </Card>
            <Card className='bg-secondary-subtle mb-4'>
                <Card.Header className='text-uppercase text-center fs-3' data-aos="flip-up" data-aos-duration="1500">
                    {appLanguage === 'hi' ? `${mt.mt_name_hi} की बैठक के कार्यवृत्त` : `MINUTES OF MEETINGS OF ${mt.mt_name}` }
                </Card.Header>
                <Card.Body>
                    <Card className='mb-3'>
                        <Card.Body>
                            <form onSubmit={MeetingSearch}>
                            <div className='mb-2 fw-bold'>{appLanguage === 'hi' ? 'खोजें' : 'SEARCH'}</div>
                            <Row className='g-2'>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={appLanguage === 'hi' ? 'शीर्षक/विषय के आधार पर खोजें' : 'Search by Title/Subject'} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{appLanguage === 'hi' ? 'वर्ष' : 'Year'}</option>
                                        {setYearList(1,0).map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{appLanguage === 'hi' ? 'महीना' : 'Month'}</option>
                                        {setMonthList().map(({ value, label }) => (
                                        <option key={value} value={value}>
                                            {label}
                                        </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                    <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {appLanguage === 'hi' ? 'खोजें' : 'SEARCH'}</Button>
                                </Col>
                            </Row>
                            </form>
                        </Card.Body>
                    </Card>
                    <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                        <thead>
                            <tr>
                                <th className="w-50">{appLanguage === 'hi' ? 'बैठक का कार्यवृत्त' : 'MINUTES OF MEETING'}</th>
                                <th>{appLanguage === 'hi' ? 'अपलोड की तिथि' : 'Date of Upload'}</th>
                                <th>{appLanguage === 'hi' ? 'डाउनलोड' : 'Download'}</th>
                            </tr>
                        </thead>
                        {isLoading ? (
                        <tbody>
                        {[...Array(10)].map((_,index) => (
                            <tr key={index}> 
                                <th className="table-success"><Placeholder xs={10} bg="success" /></th>
                                <td><Placeholder xs={10} bg="dark" /></td>
                                <td className="text-center"><Button className="btn btn-light w-100"><Placeholder xs={10} bg="dark" /></Button></td>
                            </tr>
                        ))}
                        </tbody>
                        ) : (
                        <tbody>
                        {Meeting.map((sm,index)=>(
                            <tr key={index}>
                                <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name}}></th>
                                <td>{formatDate(sm.sm_date)}</td>
                                <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sm.smFile,sm.smFileHi)}} />                                
                            </tr>
                        ))}
                        </tbody>
                        )}
                    </Table>                 
                </Card.Body>
            </Card>
        </div>
        ))}
        </React.Fragment>       
        )}
        </React.Fragment>
    ); 
}
export default Meetings;